import React, { Component, cloneElement, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import {
  List,
  downloadCSV,
  Pagination,
  Datagrid,
  DateField,
  ReferenceField,
  TextField,
  BooleanField,
  ShowButton,
  Filter,
  ReferenceInput,
  AutocompleteInput,
  TextInput,
  SelectInput,
  TopToolbar,
  RefreshButton,
  ExportButton,
  usePermissions,
  useRecordContext,
  useResourceContext,
  DateInput,
  required
} from "react-admin";
import {
  ExpectedDateField,
  CamelCaseField,
  PaymentAmountField,
} from "./common";
import {
  getDigitalOrderStatusChoices,
  getLocalStorageKey,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
} from "../common/common";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import moment from "moment";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useLocation } from "react-router-dom";

const selectInputStyle = {
  width: 200,
};

const DigitalOrdersFilter = ({ permissions, ...props }) => {
  const sdoFieldSettings = getLocalStorageKey("sdo_field_settings");
  const isMdd = getLocalStorageKey("enable_mdd_mode");
  const isFca = getLocalStorageKey("enable_fca_mode");
  let modeOfDeliveryArray = [
    { id: "self_collect", name: "Self Collect" },
    { id: "delivered", name: "Delivered" },
  ];

  if (isMdd) {
    modeOfDeliveryArray.push({ id: "MDD", name: "MDD" });
  }

  if (isFca) {
    modeOfDeliveryArray.push({ id: "agency", name: "Agency" });
  }

  // const handleChange = (event) => {
  //     console.log('event selected=====>', event);
  //     let now = new Date();
  //     // let start = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0,0,0,0));
  //     event = (moment(event).subtract(2, 'days').format("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")); //((moment(event).format('MM/DD/YYYY')) - (moment(event).add(2, 'days').format('MM/DD/YYYY')));
  //     console.log('new modified event=====>', event);
  //     return event;
  // };
  // const dateFormatter = v => {
  //     // v is a `Date` object
  //     if (!(v instanceof Date) || isNaN(v)) return;
  //     console.log('v====>',v);
  //     const pad = '00';
  //     const yy = v.getFullYear().toString();
  //     const mm = (v.getMonth() + 1).toString();
  //     const dd = v.getDate().toString();
  //     console.log('return val====>',`${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`);
  //     return `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
  //   };

  //   const dateParser = v => {
  //     // v is a string of "YYYY-MM-DD" format
  //     const match = /(\d{4})-(\d{2})-(\d{2})/.exec(v);
  //     if (match === null) return;
  //     const d = new Date(match[1], parseInt(match[2], 10) - 1, match[3]);
  //     if (isNaN(d)) return;
  //     console.log('d====>', d);
  //     return d;
  //   };
  //format={dateFormatter} parse={dateParser}

  return (
    <Filter {...props}>
      <ReferenceInput
        label="Sold To Name"
        source="business_id"
        reference="businesses"
        linkType="show"
        allowEmpty
      >
        <AutocompleteInput optionText="name" label="Sold To" />
      </ReferenceInput>
      <ReferenceInput
        label="Plant Name"
        source="sap_plant_id"
        reference="sap_plants"
        linkType="show"
        allowEmpty
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <TextInput source="order_number" defaultValue="" />
      <SelectInput
        style={selectInputStyle}
        source="mode_of_delivery"
        choices={modeOfDeliveryArray}
        validate={required()}
      />
      <DateInput
        source="date_from"
        label="Order Date From"
        maxDate={new Date()}
      />
      <DateInput source="date_to" label="Order Date To" maxDate={new Date()} />
      {getDigitalOrderStatusChoices().length > 0 && (
        <SelectInput
          source="customer_order_status"
          label="Order Status"
          choices={getDigitalOrderStatusChoices()}
          validate={required()}
        />
      )}
      {permissions === "isSap" &&
        props.resource !== "sap_digital_app_orders" &&
        getLocalStorageKey("show_all_orders") && (
          <SelectInput
            source="is_app_order"
            label="Is App Order"
            choices={[
              { id: "Yes", name: "Yes" },
              { id: "No", name: "No" },
            ]}
            validate={required()}
          />
        )}
      {permissions === "isSap" &&
        props.resource === "sap_digital_app_orders" && (
          <SelectInput
            source="on_hold"
            label="On Hold"
            choices={[
              { id: "true", name: "Yes" },
              { id: "false", name: "No" },
            ]}
            validate={required()}
          />
        )}
      {sdoFieldSettings &&
        sdoFieldSettings.shipment_number &&
        sdoFieldSettings.shipment_number.enabled && (
          <TextInput source="shipment_number" defaultValue="" />
        )}
      {sdoFieldSettings &&
        sdoFieldSettings.load_number &&
        sdoFieldSettings.load_number.enabled && (
          <TextInput source="load_number" defaultValue="" />
        )}
      <TextInput source="product" defaultValue="" />
      <TextInput source="ordered_quantity" defaultValue="" />
      <SelectInput
        source="received"
        label="Received"
        choices={[
          { id: true, name: "Yes" },
          { id: false, name: "No" },
        ]}
        validate={required()}
      />
      <SelectInput
        style={selectInputStyle}
        source="is_app_order"
        label="Show App Orders"
        choices={[
          { id: true, name: "Yes" },
          { id: false, name: "No" },
        ]}
        validate={required()}
      />
      {permissions === "isSap" && <TextInput source="logon_order_no" label="Delivery number" defaultValue="" /> }
    </Filter>
  );
};

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

// const ListActions = ({
//     displayedFilters,
//     filters,
//     filterValues,
//     resource,
//     showFilter,
//     total,
//     currentSort,
//     exporter
// }) => (
//         <TopToolbar>
//             {filters && React.cloneElement(filters, {
//                 resource,
//                 showFilter,
//                 displayedFilters,
//                 filterValues,
//                 context: 'button',
//             })}
//             <ExportButton
//                 disabled={total === 0}
//                 resource={resource + '_csv'}
//                 sort={currentSort}
//                 filter={filterValues}
//                 exporter={exporter}
//             />
//             <RefreshButton />
//         </TopToolbar>
//     )

// const ListActions = (props) => {
//     const [modalShow, setModalShow] = React.useState(false);
//     const [modalMsg, setModalMsg] = React.useState('')
//     const { resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters } = props;
//     const csvResource = resource + '_csv'
//     const options = CommonHeaderOption();
//     const apiUrl = RUN_TIME_API_ENDPOINT;

//     const callExport = (e) => {
//       e.preventDefault();
//       console.log('...', window.location.href, `${apiUrl}/${resource}_csv`)
//       options.method = 'GET';
//       fetch(`${apiUrl}/${resource}_csv?filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D`, options)
//         .then(res => {
//             return res.json();
//         }).then(jsonD => {
//           console.log('jsonD VVVVVVx===>', jsonD.data);
//           const msg = jsonD.data? jsonD.data[0].message : '';
//           setModalShow(true);
//           setModalMsg(msg);
//         });
//     }
//     const exporterModal = () => {
//       return ''
//     }

//     const onClose = () => {
//       setModalShow(false)
//     }
//     return (
//       <React.Fragment>
//       <TopToolbar>
//         {filters && cloneElement(filters, {
//           resource,
//           showFilter,
//           displayedFilters,
//           filterValues,
//           context: 'button',
//         })}
//         <RefreshButton />
//         <ExportButton
//           onClick={(e) => callExport(e)}
//           disabled={total === 0}
//           resource={csvResource}
//           sort={currentSort}
//           filter={{ ...filterValues, ...permanentFilter }}
//           exporter={exporterModal}
//           maxResults={maxResults}
//           />
//       </TopToolbar>
//       {
//             modalShow &&
//             <Modal open={modalShow} onClose={onClose} center>
//               <h3>{modalMsg}</h3>
//             </Modal>
//       }
//       </React.Fragment>
//     )
//   }

const ListActions = (props) => {
  const location = useLocation();
  const resource = useResourceContext();

  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(
    // 'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D'
    location.search
  );

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    // console.log('callExport...e', e);
    console.log("...", location.pathname, `${apiUrl}/${resource}_csv`);
    options.method = "GET";
    let _url = location.pathname.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");
      setCustomFilterUrl(_url[1]);
      fetch(`${apiUrl}/${resource}_csv?${_url[1]}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data[0].result);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          const res = jsonD.data[0].result;
          const f_date = moment(jsonD.data[0].f_date).format("MM/DD/YYYY");
          const t_date = moment(jsonD.data[0].t_date).format("MM/DD/YYYY");
          // console.log('f_date= inside callback', moment(f_date).format('MM/DD/YYYY'));
          Swal.fire({
            html:
              res && msg
                ? msg + "&nbsp" + f_date + "&nbspto&nbsp" + t_date
                : msg,
            icon: res ? "success" : "info",
            width: 640,
          });
          // this.setState({ modalShow: true });
          // this.setState({ modalMsg: msg });
        });
    } else {
      setCustomFilterUrl(
        // 'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D'
        location.search
      );
      fetch(
        `${apiUrl}/${resource}_csv?${location.search}`,
        options
      )
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          const res = jsonD.data[0].result;
          const f_date = moment(jsonD.data[0].f_date).format("MM/DD/YYYY");
          const t_date = moment(jsonD.data[0].t_date).format("MM/DD/YYYY");
          Swal.fire({
            html:
              res && msg
                ? msg + "&nbsp" + f_date + "&nbspto&nbsp" + t_date
                : msg,
            icon: res ? "success" : "info",
            width: 640,
          });
        });
    }
  };
  const exporterModal = () => {
    return "";
  };

  const onClose = () => {
    setModalShow(false);
  };

  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
  } = props;
  const csvResource = resource + "_csv";
  return (
    <React.Fragment>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <RefreshButton />
        {/* <ExportButton
                        onClick={(e) => this.callExport(e)}
                        disabled={total === 0}
                        resource={csvResource}
                        sort={currentSort}
                        filter={{ ...filterValues, ...permanentFilter }}
                        exporter={this.exporterModal}
                        maxResults={maxResults}
                    /> */}
        <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            disabled={total === 0}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          >
            {<GetAppIcon />}
            <span>Export</span>
          </button>
        </div>
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </React.Fragment>
  );
};

// const digitalOrdersExporter = (digitalOrders, fetchRelatedRecords, permissions) => {
//     fetchRelatedRecords(digitalOrders, 'business_id', 'businesses').then(businesses => {
//         const ordersForExport = digitalOrders.map(order => ({
//             ...order,
//             sold_to_name: businesses[order.business_id].name,
//             expected_date: `${moment(order.delivery_date_from).format('MM/DD/YYYY')} - ${moment(order.delivery_date_from).add(2, 'days').format('MM/DD/YYYY')}`,
//             order_date: moment(order.creation_date).format('MM/DD/YYYY, H:mm:ss a'),
//             order_status: order.customer_order_status_desc,
//             ship_to_name: order.business_site,
//             local_po_note: order.customer_ref_number,
//             first_seen_in_lr: moment(order.created_at).format('MM/DD/YYYY, H:mm:ss a'),
//         }));
//         const fieldsArr = ['order_date', 'sold_to_name', 'order_number', 'mode_of_delivery', 'products', 'shipment_nos', 'load_nos', 'received', 'order_status', 'ship_to_name', 'expected_date', 'local_po_note', 'on_hold'] // select and order fields in the export
//         if (permissions === 'isSap') {
//             fieldsArr.push('first_seen_in_lr')
//         }
//         const csv = convertToCSV({
//             data: ordersForExport,
//             fields: fieldsArr
//         });
//         const BOM = '\uFEFF'
//         downloadCSV(`${BOM} ${csv}`, 'digitalOrders')
//         // downloadCSV(csv, 'digitalOrders'); // download as 'digitalOrders.csv` file
//     });
// }

const DigitalOrdersPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 50, 100, 150, 200]} {...props} />
);

const FormattedOrderNumber = ({ source }) => {
  const record = useRecordContext();
  return (
    <span
      className={record.sap_order_failed_message ? "e1-error" : ""}
      style={{
        fontSize: "0.875rem",
        // fontFamily: "NeueEinstellung,Arial,sans-serif",
        fontWeight: "400",
        lineHeight: "1.43",
      }}
    >
      {record.order_number}
    </span>
  );
};

const DigitalOrdersList = (props) => {
  // state = {
  //     moodalShow: false,
  // }
  // exporter = (data) => {
  //     const msg = data[0].message;
  //     this.setState({
  //         moodalShow: true,
  //         modalMsg: msg,
  //     })
  // }

  // onClose = () => {
  //     this.setState({
  //         moodalShow: false,
  //     })
  // }

  console.log("props for digital orders==>", props);
  const showAllOrders = getLocalStorageKey("show_all_orders");
  const sdoFieldSettings = getLocalStorageKey("sdo_field_settings");
  const { permissions } = usePermissions();
  return (
    <React.Fragment>
      <Scrollbars className="scroll-container">
        <List
          title="Digital Orders"
          pagination={<DigitalOrdersPagination />}
          sort={{ field: "creation_date", order: "DESC" }}
          actions={<ListActions />}
          {...props}
          filters={<DigitalOrdersFilter permissions={permissions} />}
        >
          <Datagrid rowClick="show" bulkActionButtons={false}>
            <DateField label={"Order Date"} source="creation_date" showTime />
            <ReferenceField
              label="Sold To Name"
              source="business_id"
              reference="businesses"
              link="show"
              allowEmpty
            >
              <TextField source="name" />
            </ReferenceField>
            <FormattedOrderNumber source="order_number" />
            <TextField source="sap_plant" label="Plant Name" sortable={false} />
            <CamelCaseField
              source="mode_of_delivery"
              label="Mode Of Delivery"
            />
            <TextField source="is_app_order" sortable={false} />
            <TextField
              source="products"
              label={`${
                permissions === "isManual"
                  ? "(Ordered Qty/Dispatched Qty) Products"
                  : "(Ordered Qty) Products"
              }`}
              sortable={false}
            />
            {sdoFieldSettings &&
              sdoFieldSettings.shipment_number &&
              sdoFieldSettings.shipment_number.enabled && (
                <TextField source="shipment_nos" />
              )}
            {sdoFieldSettings &&
              sdoFieldSettings.load_number &&
              sdoFieldSettings.load_number.enabled && (
                <TextField source="load_nos" />
              )}
            <TextField source="received" sortable={false} />
            <TextField
              label="Order Status"
              source="customer_order_status_desc"
            />
            <ReferenceField
              label="Ship To Name"
              source="sap_business_site_id"
              reference="sap_business_sites"
              link="show"
              allowEmpty
            >
              <TextField source="name" />
            </ReferenceField>
            <ExpectedDateField
              label="Expected Date"
              source="delivery_date_from"
            />
            <TextField label="Local PO / Note" source="customer_ref_number" />
            <TextField source="payment_method" />
            <PaymentAmountField source="payment_amount" />
            <TextField source="payment_status" />
            {permissions === "isSap" && (
              <DateField label="Date 1st seen in LR" source="created_at" />
            )}
            {permissions === "isSap" &&
              props.resource !== "sap_digital_app_orders" &&
              showAllOrders && (
                <TextField label="Is App Order" source="is_app_order" />
              )}
            {permissions === "isSap" &&
              props.resource === "sap_digital_app_orders" && (
                <BooleanField label="On Hold" source="on_hold" />
              )}
            {/* {
                        permissions === 'isManual' &&
                        <EditButton />
                    } */}
            <ShowButton />
          </Datagrid>
        </List>
      </Scrollbars>
      {/* {
                    state.moodalShow &&
                    <Modal open={state.moodalShow} onClose={this.onClose} center>
                        <h3>{state.modalMsg}</h3>
                    </Modal>
                } */}
    </React.Fragment>
  );
};

export default DigitalOrdersList;
